import { Empty } from "antd";
import React from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

// const RADIAN = Math.PI / 180;

const RenderPieChart = (props) => {
  // console.log("render", props.data, props.dataline)
  // eslint-disable-next-line eqeqeq
  if (props.data.length == 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }
  return (
    <ResponsiveContainer height={250}>
      <PieChart>
        <Pie
          data={props.data}
          cx={215}
          cy={150}
          startAngle={180}
          endAngle={0}
          innerRadius={120}
          outerRadius={150}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="num"
        >
          {props.data.map((entry, index) => (
            <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default RenderPieChart;
